import { HolidayProfile } from 'domain-types';

export type HolidayProfileCountry = HolidayProfile['country'];

export const defaultHolidayProfile: HolidayProfile = {
  country: 'NL',
  includeGoodFriday: false,
  liberationDayMode: 'every_5_years'
};

export const createHolidayProfile = (
  country: HolidayProfileCountry
): HolidayProfile =>
  country === 'NL'
    ? { ...defaultHolidayProfile }
    : {
        country
      };

export const getConfiguredHolidayProfile = (
  holidayProfile?: HolidayProfile | null
): HolidayProfile => ({
  ...createHolidayProfile(
    holidayProfile?.country ?? defaultHolidayProfile.country
  ),
  ...(holidayProfile ?? {})
});
